<template>
  <!-- 头部整体盒子 -->
  <div> 
    <div class="header-two">
      <!-- 导航logo -->
      <div class="header-two-logo">
        <img src="@/assets/img/toefl/logo2.png" />
      </div>
      <ul class="header-two-wrapper" v-if="testReport">
        <li v-for="(item, index) in navList[navIndex].children" :key="index">
          <el-popover
            v-if="index > 0 && index != 5"
            placement="bottom"
            width="280"
            trigger="hover"
          >
            <headPopover
              :navindex="index"
              :data="data[index - 1]"
            ></headPopover>
            <el-button slot="reference" type="text" size="16px" 
              >{{ item.name }}<i class="el-icon-caret-bottom"></i
            ></el-button>
          </el-popover>
          <el-button type="text" v-else @click="jump(item.path)">{{
            item.name
          }}</el-button>
        </li>
      </ul>
    </div>
    <div class="shadow"></div>
  </div>
</template>
<script>
import headPopover from "@/components/gre/dialog/headPopover.vue";

export default {
  name: "headerTwoGre",
  components: { headPopover },
  data() {
    return {
      // navIndex: this.$store.state.navIndex,
      navIndex: 1,
      testReport: true,
    };
  },
  computed: {
    navList() {
      return [
        {},
        {
          children: [
            {
              name: this.$t("GRE Home"),
              path: "/gre",
            },
            {
              name: this.$t("Exam Mock"),
              path: "/toefl/tpo/exam",
              children: [],
            },
            {
              name: this.$t("Chinese"),
              path: "/",
              children: [],
            },
            {
              name: this.$t("Maths"),
              path: "/",
              children: [], 
            },
            {
              name: this.$t("Writing"),
              path: "/",
              children: [],
            },
            {
              name: this.$t("Search"),
              path: "/gre/search",
              children: [],
            },
          ],
        },
      ];
    },
    data() {
      return [
        {
          bottom: this.$t("disclosed All Free"),
          list: [
            {
              title: this.$t("Exam Mock"),
              img: "ico-exercise1",
              src: this.$t("写作.语文.数学一起模考"),
              width: "28px",
              height: "28px",
            },
          ],
        },
        {
          // bottom: this.$t("2014-2015年阅读真题免费"),
          list: [
            {
              title: this.$t("单个Section练习"),
              img: "ico-exercise1",
              src: this.$t("1个Section练习/模考"),
              width: "28px",
              height: "28px",
            },
            {
              title: this.$t("阅读与逻辑"),
              img: "ico-exercise2",
              src: this.$t("多篇/单篇文章练习"),
              width: "24px",
              height: "28px",
            },
            {
              title: this.$t("等价与填空"),
              img: "ico-exercise3",
              src: this.$t("多个/单个题目练习"),
              width: "29px",
              height: "29px",
            },
          ],
        },
        {
          // bottom: this.$t("套题外真题:与套题内真题不重复"),
          list: [
            {
              title: this.$t("单个Section练习"),
              img: "ico-exercise1",
              src: this.$t("1个Section练习/模考"),
              width: "28px",
              height: "28px",
            },
            {
              title: this.$t("知识点练习"),
              img: "ico-exercise2",
              src: this.$t("多个/单个根据知识点练习"),
              width: "24px",
              height: "28px",
            },
            {
              title: this.$t("题型练习"),
              img: "ico-exercise3",
              src: this.$t("多个/单个根据题目类型练习"),
              width: "29px",
              height: "29px",
            },
          ],
        },
       
        {
          // bottom: this.$t("套题外真题:与套题内真题不重复"),
          list: [
            {
              title: this.$t("Issue练习"),
              img: "ico-exercise1",
              src: this.$t("Issue单个题目练习"),
              width: "28px",
              height: "28px",
            },
            {
              title: this.$t("Argument练习"),
              img: "ico-exercise2",
              src: this.$t("Argument单个题目练习"),
              width: "24px",
              height: "28px",
            }
          ],
        },
      ];
    },
  },
  methods: {
    show(obj) {
      alert(obj);
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    jump(pathName) {
      if (this.$route.path != pathName) {
        this.$router.push({ path: pathName });
      }
    },
  },
  created() {},
  watch: {
    "$route.path": {
      handler(newVal, oldName) {
        if (newVal === "/toefl/testReport") {
          this.testReport = false;
        } else {
          this.testReport = true;
        }
      },
      immediate: true, //true就表示会立即执行
    },
  },
  beforeCreate() {},
};
</script>
<style scoped>
/* 顶部 */

/* 导航栏logo */
.header-two {
  width: 1202px;
  overflow: hidden;
  margin: auto;
  height: 80px;
  position: relative;
}
/* 导航栏logo图片 */
.header-two-logo {
  width: 93px;
  height: 27px;
  position: absolute;
  top: 28px;
  left: 0;
  right: 0;
  bottom: 0;
}
.header-two-logo img {
  width: 93px;
  height: 27px;
}
.header-two-wrapper {
  line-height: 40px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 导航容器
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 40px;
} */

.header-two .header-two-wrapper > li {
  float: left;
  position: relative;
  margin: 0 20px;
  font-size: 16px;
  font-weight: 400;
  color: #7a8da1;
  line-height: 80px;
  cursor: pointer;
}
.header-two .header-two-wrapper > li > a {
  color: #7a8da1;
  position: relative;
}
.header-two .header-two-wrapper > li > i {
  position: absolute;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top-color: #7b8b8e;
  top: 37.5px;
  margin-left: 6px;
}

#header .header-two .header-two-wrapper > li:last-child {
  margin-right: 0;
}
.header-two /deep/ .el-button {
  font-size: 16px !important;
  font-weight: 400 !important;
}
.header-two /deep/ .el-button--text {
  color: #7a8da1 !important;
}
.shadow {
  width: 100%;
  height: 5px;
  background: linear-gradient(
    to bottom,
    rgba(239, 239, 239, 0.8),
    rgba(254, 254, 254, 1)
  );
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/gre/common/headerTwo.vue